
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.29.729v1.285l1.289.004-1.29-1.29z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.814 2.96a.474.474 0 01-.473-.473V0h-9.21a.474.474 0 00-.475.474v15.052c0 .262.213.474.474.474h11.71a.474.474 0 00.475-.474V2.969l-2.501-.008zM4.764 4.31h3.221a.474.474 0 010 .948h-3.22a.474.474 0 010-.948zm5.927 6.56H4.765a.474.474 0 010-.947h5.926a.474.474 0 010 .948zm0-1.858H4.765a.474.474 0 010-.948h5.926a.474.474 0 010 .948zm0-1.89H4.765a.474.474 0 010-.948h5.926a.474.474 0 010 .949z","fill":"#fff"}})])
          )
        }
      }
    